export default Object.freeze({
  Direct: 'Direct',
  RoundTripRedirect: 'RoundTripRedirect',
  OnewayRedirect: 'OnewayRedirect',
})
